import { render } from "./PointConfirmation.vue?vue&type=template&id=9b874794&ts=true"
import script from "./PointConfirmation.vue?vue&type=script&lang=ts"
export * from "./PointConfirmation.vue?vue&type=script&lang=ts"

import "./PointConfirmation.vue?vue&type=style&index=0&id=9b874794&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__